var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      staticStyle: { margin: "0 10%" },
      attrs: {
        row: "",
        "justify-center": "",
        "align-center": "",
        "fill-height": ""
      }
    },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "", sm12: "", md12: "", "order-md1": "" } },
        [
          _c("div", { staticClass: "vv-heading text-xs-center text-md-left" }, [
            _vm._v(_vm._s(_vm.title))
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "vv-subheading  text-xs-center text-md-left" },
            [_vm._v("\n            " + _vm._s(_vm.subtitle) + "\n          ")]
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "vv-subheading  text-xs-center text-md-left" },
            [_vm._v("\n            " + _vm._s(_vm.end) + "\n          ")]
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { staticClass: "vv-cta right" },
            [
              _c(
                "v-btn",
                {
                  attrs: { target: "_blank", dark: "", color: "black" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.redirectUser()
                    }
                  }
                },
                [_vm._v("Try Our Demo!\n          ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e4731dd0", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e4731dd0","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Welcome.vue
// module id = null
// module chunks = 